module.exports = __webpack_public_path__ + "static/media/muerteTotal.8e008eca.png";